import styled from 'styled-components';
import tw from 'twin.macro';
import { Meta } from '../../styled components/Typography';

export const TitleHeaderContainer = styled.div(({ $variant }) => [
  /* variant primary specific styles */
  $variant === 'primary' && tw`bg-blue-lighten-40 flex flex-grow`,

  /* variant secondary specific styles */
  $variant === 'secondary' && tw`bg-inherit`
]);
export const TitleHeaderContent = styled.div(({ $variant }) => [
  tw`p-4 border-solid flex flex-grow`,
  /* variant primary specific styles */
  $variant === 'primary' && tw`border-blue-lighten-30 border-t border-b`,
  /* variant secondary specific styles */
  $variant === 'secondary' && tw`border-silver-base border-b`
]);

export const TitleHeaderContentLabel = styled(Meta).attrs(() => ({
  as: 'h2'
}))(({ $variant }) => [
  tw`leading-normal items-start flex-grow`,
  $variant === 'secondary' && tw`items-center`
]);
